import { render, staticRenderFns } from "./assessmentRecord.vue?vue&type=template&id=6b8b492c&scoped=true"
import script from "./assessmentRecord.vue?vue&type=script&lang=js"
export * from "./assessmentRecord.vue?vue&type=script&lang=js"
import style0 from "./assessmentRecord.vue?vue&type=style&index=0&id=6b8b492c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8b492c",
  null
  
)

export default component.exports